import { render, staticRenderFns } from "./form_list.vue?vue&type=template&id=6e87d9d0&scoped=true&"
import script from "./form_list.vue?vue&type=script&lang=js&"
export * from "./form_list.vue?vue&type=script&lang=js&"
import style0 from "./form_list.vue?vue&type=style&index=0&id=6e87d9d0&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e87d9d0",
  null
  
)

export default component.exports